import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';

/**
 * <FormatMeasure value={int} valueToNextUnit={int} textComponent={'string'}, render={func} />
 */
const FormatMeasure = injectIntl(
  ({
    value,
    valueToNextUnit = 250,
    textComponent,
    render,
    intl: {
      messages: { units },
    },
    ...props
  }) => {
    const isNextValue = (valueToCheck) =>
      valueToNextUnit > 0 ? valueToCheck < valueToNextUnit : valueToCheck;
    const getUnit = (valueToCheck) => (isNextValue(valueToCheck) ? units.cm : units.m);
    const renderTextNode = (result, unit) => `${result}${unit}`;
    const renderCustomElement = (node, nodeText) => React.createElement(node, null, nodeText);

    return (
      <FormattedNumber
        value={isNextValue(value) ? value : value / 100}
        useGrouping={true}
        style={`decimal`}
        children={(result) =>
          render
            ? render(result, getUnit(value))
            : renderCustomElement(textComponent || 'span', renderTextNode(result, getUnit(value)))
        }
        {...props}
      />
    );
  }
);

FormatMeasure.propTypes = {
  intl: PropTypes.any,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default FormatMeasure;
